$(function() {
$(".closecbox").click(function(){
    $(".cheatbox").hide();
})
$("#product-add-to-cart").val(""); 
  
  

  if (window.location.href.indexOf("?") > -1) {
     $(".cheatbox").show();
    }

  $(".cheatpopup").click(function(){
    $(".cheatbox").fadeIn(500);
  })

  
  $(".qzs").niceSelect();
  $(".qzs1").niceSelect();
  $(".cheatboxcon select").niceSelect();
 
$( ".custom-colorx a" ).hover(
  function() {
   $(this).addClass("active"); 
  }, function() { 
   $(this).removeClass("active");
  }
);
  
    $(function() {
        $('.beefup').beefup();
    });
  
  $(".ctab").click(function(){
$(".ctab").removeClass("active");
$(this).addClass("active");
var pp=$(this).attr("data-action");
$(".pctab").hide();
$("."+pp).show();
})
  
  $(".bolt2").click(function(){
$(".hli").toggleClass("active");
})
  
  $(".dropdow-mb").click(); 
  
  
  $(".collection-template .atc").click();


  
   $(".collection-template .atc").click();
  
  
  $(".prdblktop .atc").click();
  
  
  
  
  
  
$(".custom-color a").on({
    mouseenter: function () {
        //stuff to do on mouse enter
$(this).find("span").show();
    },
    mouseleave: function () {
        //stuff to do on mouse leave
$(this).find("span").hide();
    }
});


var swiper = new Swiper(".bslider", {
   slidesPerView: 1,
        spaceBetween: 0,
  centeredSlides:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
  
  var swiper4 = new Swiper(".myxSwiper", {
   slidesPerView: 1,
        spaceBetween: 0,
  centeredSlides:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
  
  
  
  
  
  var swiper1 = new Swiper(".mySwiper", {
    slidesPerView: 5,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });



 
 
});



  var swiper1 = new Swiper(".mySwiperbvx", {
    slidesPerView: 1,
       navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });



new Swiper(".mySwiperx", {
			slidesPerView: 1,
			spaceBetween: 2,
              

  scrollbar: {
          el: ".swiper-scrollbar",
          draggable:true,
        },
			
				 navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
			
			mousewheel: {
				invert: false,
				forceToAxis: true
			},
			breakpoints: {
				575: {
					slidesPerView: 2,
					spaceBetween: 5
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 10
				},
				1200: {
					slidesPerView: 4.5,
					spaceBetween: 10
				}
			}
		});

 
 new Swiper(".mySwiperfs", {
			slidesPerView: 1,
			spaceBetween: 2,

  scrollbar: {
          el: ".swiper-scrollbar",
          draggable:true,
        },
			
				 navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
			
			mousewheel: {
				invert: false,
				forceToAxis: true
			},
			breakpoints: {
				575: {
					slidesPerView: 2,
					spaceBetween: 5
				},
				992: {
					slidesPerView: 3.5,
					spaceBetween: 30
				},
				1200: {
					slidesPerView: 3.5,
					spaceBetween: 40
				}
			}
		});


$('#csel').on('change', function() {
 
  $('#cstate option').each(function() {
   
        $(this).remove();
    
});
  var csel=this.value;
 
  if (csel == "Canada"){
    console.log("can")
    $("#cstate").append(' <option class="dcan" value="Alberta">Alberta</option><option class="dcan" value="British Columbia">British Columbia</option><option class="dcan" value="Manitoba">Manitoba</option><option class="dcan" value="New Brunswick">New Brunswick</option><option class="dcan" value="Newfoundland and Labrador">Newfoundland and Labrador</option><option class="dcan" value="Nova Scotia">Nova Scotia</option><option class="dcan" value="Northwest Territories">Northwest Territories</option><option class="dcan" value="Nunavut">Nunavut</option><option class="dcan" value="Ontario">Ontario</option><option class="dcan" value="Prince Edward Island">Prince Edward Island</option><option class="dcan" value="Quebec">Quebec</option><option class="dcan" value="Saskatchewan">Saskatchewan</option><option class="dcan" value="Yukon">Yukon</option>');
    $("#cstate").niceSelect('update');
  }
  else if(csel== "United States"){
    $("#cstate").append('<option class="dusa" value="Alabama">Alabama</option><option class="dusa" value="Alaska">Alaska</option><option class="dusa" value="Arizona">Arizona</option><option class="dusa" value="Arkansas">Arkansas</option><option class="dusa" value="California">California</option><option class="dusa" value="Colorado">Colorado</option><option class="dusa" value="Connecticut">Connecticut</option><option class="dusa" value="Delaware">Delaware</option><option class="dusa" value="District Of Columbia">District Of Columbia</option><option class="dusa" value="Florida">Florida</option><option class="dusa" value="Georgia">Georgia</option><option class="dusa" value="Hawaii">Hawaii</option><option class="dusa" value="Idaho">Idaho</option><option class="dusa" value="Illinois">Illinois</option><option class="dusa" value="Indiana">Indiana</option><option class="dusa" value="Iowa">Iowa</option><option class="dusa" value="Kansas">Kansas</option><option class="dusa" value="Kentucky">Kentucky</option><option class="dusa" value="Louisiana">Louisiana</option><option class="dusa" value="Maine">Maine</option><option class="dusa" value="Maryland">Maryland</option><option class="dusa" value="Massachusetts">Massachusetts</option><option class="dusa" value="Michigan">Michigan</option><option class="dusa" value="Minnesota">Minnesota</option><option class="dusa" value="Mississippi">Mississippi</option><option class="dusa" value="Missouri">Missouri</option><option class="dusa" value="Montana">Montana</option><option class="dusa" value="Nebraska">Nebraska</option><option class="dusa" value="Nevada">Nevada</option><option class="dusa" value="New Hampshire">New Hampshire</option><option class="dusa" value="New Jersey">New Jersey</option><option class="dusa" value="New Mexico">New Mexico</option><option class="dusa" value="New York">New York</option><option class="dusa" value="North Carolina">North Carolina</option><option class="dusa" value="North Dakota">North Dakota</option><option class="dusa" value="Ohio">Ohio</option><option class="dusa" value="Oklahoma">Oklahoma</option><option class="dusa" value="Oregon">Oregon</option><option class="dusa" value="Pennsylvania">Pennsylvania</option><option class="dusa" value="Rhode Island">Rhode Island</option><option class="dusa" value="South Carolina">South Carolina</option><option class="dusa" value="South Dakota">South Dakota</option><option class="dusa" value="Tennessee">Tennessee</option><option class="dusa" value="Texas">Texas</option><option class="dusa" value="Utah">Utah</option><option class="dusa" value="Vermont">Vermont</option><option class="dusa" value="Virginia">Virginia</option><option class="dusa" value="Washington">Washington</option><option class="dusa" value="West Virginia">West Virginia</option><option class="dusa" value="Wisconsin">Wisconsin</option><option class="dusa" value="Wyoming">Wyoming</option>')
  $("#cstate").niceSelect('update');
  }
  else{
     $('#cstate option').each(function() {
   
        $(this).remove();
    
});
    $("#cstate").niceSelect('update');
  }
});


$('document').ready(function() {
 
 $("#cstate").append('<option class="dusa" value="Alabama">Alabama</option><option class="dusa" value="Alaska">Alaska</option><option class="dusa" value="Arizona">Arizona</option><option class="dusa" value="Arkansas">Arkansas</option><option class="dusa" value="California">California</option><option class="dusa" value="Colorado">Colorado</option><option class="dusa" value="Connecticut">Connecticut</option><option class="dusa" value="Delaware">Delaware</option><option class="dusa" value="District Of Columbia">District Of Columbia</option><option class="dusa" value="Florida">Florida</option><option class="dusa" value="Georgia">Georgia</option><option class="dusa" value="Hawaii">Hawaii</option><option class="dusa" value="Idaho">Idaho</option><option class="dusa" value="Illinois">Illinois</option><option class="dusa" value="Indiana">Indiana</option><option class="dusa" value="Iowa">Iowa</option><option class="dusa" value="Kansas">Kansas</option><option class="dusa" value="Kentucky">Kentucky</option><option class="dusa" value="Louisiana">Louisiana</option><option class="dusa" value="Maine">Maine</option><option class="dusa" value="Maryland">Maryland</option><option class="dusa" value="Massachusetts">Massachusetts</option><option class="dusa" value="Michigan">Michigan</option><option class="dusa" value="Minnesota">Minnesota</option><option class="dusa" value="Mississippi">Mississippi</option><option class="dusa" value="Missouri">Missouri</option><option class="dusa" value="Montana">Montana</option><option class="dusa" value="Nebraska">Nebraska</option><option class="dusa" value="Nevada">Nevada</option><option class="dusa" value="New Hampshire">New Hampshire</option><option class="dusa" value="New Jersey">New Jersey</option><option class="dusa" value="New Mexico">New Mexico</option><option class="dusa" value="New York">New York</option><option class="dusa" value="North Carolina">North Carolina</option><option class="dusa" value="North Dakota">North Dakota</option><option class="dusa" value="Ohio">Ohio</option><option class="dusa" value="Oklahoma">Oklahoma</option><option class="dusa" value="Oregon">Oregon</option><option class="dusa" value="Pennsylvania">Pennsylvania</option><option class="dusa" value="Rhode Island">Rhode Island</option><option class="dusa" value="South Carolina">South Carolina</option><option class="dusa" value="South Dakota">South Dakota</option><option class="dusa" value="Tennessee">Tennessee</option><option class="dusa" value="Texas">Texas</option><option class="dusa" value="Utah">Utah</option><option class="dusa" value="Vermont">Vermont</option><option class="dusa" value="Virginia">Virginia</option><option class="dusa" value="Washington">Washington</option><option class="dusa" value="West Virginia">West Virginia</option><option class="dusa" value="Wisconsin">Wisconsin</option><option class="dusa" value="Wyoming">Wyoming</option>')
  $("#cstate").niceSelect('update');
var qzs= $(".qzs").val();
Cookies.set('qzs',qzs )
  $(".qzs").change(function(){
var qzs=$(this).val()
     Cookies.set('qzs',qzs )
})
});

